<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2WBNoT/tc-custom/9781504063593.jpg?1736950894750" alt="This image is the cover for the book Crome Yellow"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Crome Yellow
      </h1>
      <p class="bookDescription body article font2">
        <p><b>An intellectual summer party at an English country house is satirized with “ingenuity, sophistication [and] impudence” by the author of <i>A Brave New World</i> (H. L. Mencken).</b></p><p>When young poet Denis Stone is invited to a party at Crome, country home of Priscilla and Henry Wimbush, he is eager to join their coterie of authors and intellectuals. The Wimbushes are famous for gathering stimulating company for extended stays. But between the philosophizing and witty repartee, drunken reveries and amorous adventures are also afoot.</p> Denis is secretly in love with his hosts’ niece Anne Wimbush. Anne, however, seems more interested in an artist named Gombauld. Meanwhile, a naïve flapper is determined to overcome her sexual repressions, Priscilla finds a kindred spirit in her fascination with occultism, and a solitary young woman records her devastating observations in a journal.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Aldous Huxley
      </h2>
      
      <p class="authorDescription body article">Aldous Huxley was an English writer and philosopher. He wrote nearly fifty books&mdash;both novels and nonfiction works&mdash;as well as wide-ranging essays, narratives, and poems. Born into the prominent Huxley family, he graduated from Balliol College, Oxford with an undergraduate degree in English literature.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?883ad286